import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FAQPageJsonLd } from 'next-seo';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Link from '@nubank/nuds-web/components/Link/Link';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Collapse from '@nubank/nuds-web/components/Collapse/Collapse';

import sanitizer from 'utils/sanitizer';

import tracking from '../../tracking';

function SectionFAQ({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  const faqQuestion = formatMessage({ id: `cms.accountPage.cardsArea[${index}].faqQuestion` });

  return (
    <>
      <Box
        tag="section"
        paddingTop={{ xs: '12x', md: '16x', lg: '32x' }}
        paddingBottom={{ xs: '12x', md: '16x', lg: '32x' }}
        paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
        display={{ lg: 'grid' }}
        gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
        gridColumnGap={{ lg: '8x' }}
      >
        <Box gridColumn={{ lg: '2 / span 6' }}>
          <Typography
            variant="title"
            intlKey={`cms.accountPage.cardsArea[${index}].title`}
            marginBottom={{ xs: '8x', md: '12x' }}
          />
        </Box>
        <Box gridColumn={{ lg: '2 / 12' }}>
          {faqQuestion.map((question, questionIndex) => (
            <Box
              marginTop={questionIndex > 0 ? { xs: '16x', md: 60, lg: 56 } : {}}
              key={question.id}
            >
              <Collapse
                id={`account-faq-${question.id}`}
                onChange={() => { tracking.faq(); }}
              >
                <Collapse.Header>
                  <Typography
                    variant="subtitle"
                    marginBottom="2x"
                  >
                    {question.title}
                  </Typography>
                </Collapse.Header>
                <Collapse.Body>
                  {formatMessage({
                    id: `cms.accountPage.cardsArea[${index}].faqQuestion[${questionIndex}].content`,
                  }, {
                    strong: props => (
                      <Typography
                        tag="strong"
                        variant="paragraph2"
                        {...props}
                      />
                    ),
                    p: props => <Typography variant="paragraph1" marginBottom={{ xs: '5x' }} {...props} />,
                  })}
                </Collapse.Body>
              </Collapse>
            </Box>
          ))}

          <Link
            marginTop={{ xs: '8x', md: 60 }}
            variant="action"
            href={formatMessage({ id: `cms.accountPage.cardsArea[${index}].ctaLink` })}
            intlKey={`cms.accountPage.cardsArea[${index}].ctaText`}
          />
        </Box>
      </Box>
      <FAQPageJsonLd mainEntity={faqQuestion.map((_, questionIndex) => ({
        questionName: sanitizer.forJSON(formatMessage({ id: `cms.accountPage.cardsArea[${index}].faqQuestion[${questionIndex}].title` })),
        acceptedAnswerText: sanitizer.forJSON(formatMessage({ id: `cms.accountPage.cardsArea[${index}].faqQuestion[${questionIndex}].content` })),
      }))}
      />
    </>
  );
}

SectionFAQ.propTypes = {
  index: PropTypes.string.isRequired,
};

export default React.memo(SectionFAQ);
